import { useFetcher, useSearchParams } from '@remix-run/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { type SelectedStoresCookie } from '#app/features/plp-clerk/clerk-components/store-selector'
import { StoreSelectorSheet } from '#app/features/plp-clerk/clerk-components/store-selector/store-selector-sheet'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'
import useUserPreferences from '#app/hooks/use-user-preferences'
import { cn } from '#app/utils/misc'

const SelectedStorePDP = () => {
	let { t } = useTranslation('product_list_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()
	const removeSelectedStoreFetcher = useFetcher()
	const userPreferences = useUserPreferences()
	const [searchParams] = useSearchParams()
	const storesParam = searchParams.getAll('store')
	const removeSelectedStore = () => {
		trackAmplitudeEvent('remove selected stores')
		removeSelectedStoreFetcher.submit(null, {
			method: 'POST',
			action: '/resources/removeSelectedStores',
		})
	}

	if (
		!userPreferences?.selectedStores ||
		userPreferences?.selectedStores?.length === 0
	)
		return null

	// if there is no params in the url we should not show the store selctor
	if (storesParam.length === 0) return null

	const selectedStores =
		userPreferences.selectedStores as SelectedStoresCookie[]

	return (
		<motion.div
			className={cn(
				'z-0 flex flex-col space-y-1 bg-beige-50-opacity px-4 py-2 md:flex-row md:space-y-0 md:px-[var(--plenty-padding)]',
			)}
			initial={{ y: -50, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{
				type: 'spring',
				stiffness: 300,
				damping: 20,
				duration: 0.35,
			}}
		>
			<div className="flex flex-col md:flex-row md:items-center md:space-x-2">
				<PlentyBody>
					{t('selected_stores_results', {
						count: selectedStores.length,
						storeName: selectedStores[0].name,
					})}
				</PlentyBody>
				<div className="flex flex-row space-x-2">
					<StoreSelectorSheet selectedStores={selectedStores} />

					<Button variant="link" onClick={removeSelectedStore}>
						<Icon name="close" size="sm" />
					</Button>
				</div>
			</div>
		</motion.div>
	)
}

export default SelectedStorePDP
